import classNames from 'classnames'

import editIcon from 'images/icons/edit.svg'

import { MODALS } from '../../constants'

import styles from './CurrenciesList.module.scss'

const CurrenciesList = ({ isLoading, currencies, onOpenModal }) => (
    <ul className={classNames(styles.currenciesList, { [styles.isLoadingCurrenciesList]: isLoading })}>
        {currencies.map(item => (
            <li key={item.id} className={styles.currency}>
                <span>{item.currency}</span>&nbsp;({item.symbol})
                <img onClick={() => onOpenModal(MODALS.EDIT_CURRENCY, item)} src={editIcon} alt="edit" />
            </li>
        ))}
        <li
            className={classNames(styles.currency, styles.isAddCurrency)}
            onClick={() => onOpenModal(MODALS.ADD_CURRENCY)}
        >
            + Add
        </li>
    </ul>
)

export default CurrenciesList
